import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import cartoonAroony from '../images/CARTOONAROONY.JPG'
import dontShootFilms from '../images/DONT SHOOT FILMS.jpg'
import softTissue from '../images/SOFT_TISSUE.jpg'
import waharoa from '../images/WAHAROA TITLE.jpg'
import duetsWithMyWhanau from '../images/DUETS W MY WHANAU.jpg'

const testData = {
  pageTitle: "CREATING",
  pageInfo: [
    `Ella is an exciting edition to the landscape of innovative creators in New Zealand.`,
    `As a maker of theatre and film she builds work that is original, provocative and human. Her style is physical, comedic and non prescriptive.`,
    `She has performed original work across major theatres in New Zealand, in rural communities, on Marae and inside prison. She has toured internationally to Singapore and Iran.`,
    `Ella is an experienced devisor; often found in the core development team of new devised work. She is good at asking questions, playing games, and moving her body.`,
    `She is regularly employed to build and run workshops for Rangatahi, engaging them powerfully in theatre experiences.`,
    `Ella is also a founding member of award winning indie film collective Don’t Shoot Films.`,
    `Companies and Festivals she has worked with include:`,
    `Tempo Dance Festival - New Zealand International Arts Festival - Auckland Arts Festival - Tawhiri Productions - Auckland Theatre Company - Movement of the Human - Barbarian Productions - New Zealand Film Commission - New Zealand Fringe Festival - Auckland Fringe Festival - Auckland Live - Super8x8 Film Festival - London Straight8 Film Festival`
  ],
  quotes: [
    {
      attribution: "Chris Jannides",
      text: `At the fore-front of the next generation of stimulating kiwi practitioners. Her voice and artistry are contemporary and she brings new vitality to the art form`
    },
    {
      attribution: "Phillipa Campbell",
      text: `Ella Gilbert’s skill and commitment to new NZ work is a hallmark of her extensive work both as a performer and teaching artist`
    },
    {
      attribution: "Theatreview",
      text: `This is a work and a performer that will stay in your mind long after the lights have gone down`
    }
  ],
  content: [
    {
      title: "DON'T SHOOT FILMS",
      link: "/dont-shoot-films",
      image: dontShootFilms
    },
    {
      title: "WAHAROA",
      link: "/waharoa",
      image: waharoa
    },
    {
      title: "CARTOONAROONY",
      link: "/cartoonaroony",
      image: cartoonAroony
    },
    {
      title: "SOFT TISSUE",
      link: "/soft-tissue",
      image: softTissue
    },
    {
      title: "DUETS WITH MY WHANAU",
      link: "/duets-with-my-whanau",
      image: duetsWithMyWhanau
    }
  ]
}

function CreatingPage() {
  const [isExpanded, setIsExpanded] = useState(false)

  function colourise(e) {
    e.target.style.filter = 'grayscale(0%)';
  }

  function makeMonotone(e) {
    e.target.style.filter = 'grayscale(100%)';
  }

  function readMore(e) {
    if(!isExpanded) {
      document.querySelector('.read-more').style.visibility = 'hidden';
      document.querySelector('.Expand').style.maxHeight = '9999px';
      setIsExpanded(true);
    }

  }

  function readLess(e) {
    document.querySelector('.read-more').style.visibility = 'visible';
    document.querySelector('.Expand').style.maxHeight = '200px';
    setIsExpanded(false);
  }

  return (
    <div className="Main-page container">
      <h1 className="title">{testData.pageTitle}</h1>
      <div className="row">
        <div className="col" onClick={readMore}>
          <div className="Main-info Expand row">
            <div className="col-md">
                <div className="Quotes">
                  <p>
                    <strong>
                      {testData.quotes[0].text}</strong>
                    <br />
              - {testData.quotes[0].attribution}
                  </p>
                </div>
                <div className="Quotes">
                  <p>
                    <strong>
                      {testData.quotes[1].text}</strong>
                    <br />
              - {testData.quotes[1].attribution}
                  </p>
                </div>
                <div className="Quotes">
                  <p>
                    <strong>
                      {testData.quotes[2].text}</strong>
                    <br />
              - {testData.quotes[2].attribution}
                  </p>
                </div>
            </div>
            <div className="col-md">
              <br />
                <p>
                  {testData.pageInfo[0]}
                </p>
                <p>
                  {testData.pageInfo[1]}
                </p>
                <p>
                  {testData.pageInfo[2]}
                </p>
                <p>
                  {testData.pageInfo[3]}
                </p>
                <p>
                  {testData.pageInfo[4]}
                </p>
                <p>
                  {testData.pageInfo[5]}
                </p>
                <p>
                  {testData.pageInfo[6]}
                </p>
                <p>
                  {testData.pageInfo[7]}
                </p>
            </div>
            <div className="row">
              <p className="read-more"></p>
              <a href="#" className="read-more-button" onClick={readLess}><strong>{isExpanded ? 'LESS' : 'MORE'}...</strong></a>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="main-pic col-md">
          <Link to={testData.content[0].link}>
            <img
              src={testData.content[0].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={makeMonotone} />
            <h1 className="title-dont-shoot-films"><strong>{testData.content[0].title}</strong></h1>
          </Link>
        </div>
        <div className="main-pic col-md">
          <Link to={testData.content[1].link}>
            <img
              src={testData.content[1].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={makeMonotone} />
            <h1 className="title-white"><strong>{testData.content[1].title}</strong></h1>
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="main-pic col-md">
          <Link to={testData.content[2].link}>
            <img
              src={testData.content[2].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={makeMonotone} />
            <h1 className="title-cartoonaroony"><strong>CARTOON&shy;AROONY­</strong></h1>
          </Link>
        </div>
        <div className="main-pic col-md">
          <Link to={testData.content[3].link}>
            <img
              src={testData.content[3].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={makeMonotone} />
            <h1 className="title-black"><strong>{testData.content[3].title}</strong></h1>
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="main-pic col-md">
          <Link to={testData.content[4].link}>
            <img
              src={testData.content[4].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={makeMonotone} />
            <h1 className="title-duets-whanau"><strong>{testData.content[4].title}</strong></h1>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default CreatingPage
